import { useMemo, useState } from 'react';
import { TEXTAREA_MAX_LENGTH, TEXTAREA_MIN_LENGTH } from '@constants/enrollments/enrollments.constants';
import { IEnrollmenFamilyMember, IEnrollment } from '../common/types';

interface IReasonState {
    overrideCommentText: string;
}

interface IPolicy {
    issuerAssignedPolicyId: string;
}

//converting enrolleeDataDtoList to familyMembers which will be used in the payload
export const useFamilyMembers = (enrollment: IEnrollment) => {
    const initialFamilyMembers: IEnrollmenFamilyMember[] = useMemo(() => {
        return enrollment.enrolleeDataDtoList.map(enrollee => ({
            exchgIndivIdentifier: enrollee.memberId,
            name: `${enrollee.firstName} ${enrollee.lastName}`,
            issuerAssignedMemberId: '',
            effectiveStartDate: enrollee.enrolleeEffectiveStartDate,
            effectiveEndDate: enrollee.enrolleeEffectiveEndDate,
            relationship: enrollee.relationshipToSubscriber,
            memberId: Number(enrollee.memberId),
        }));
    }, [enrollment.enrolleeDataDtoList]);

    const [familyMembers, setFamilyMembers] = useState<IEnrollmenFamilyMember[]>(initialFamilyMembers);

    const handleInputChange = (e: string, memberId: number) => {
        setFamilyMembers(prev =>
            prev.map(member => {
                if (member.memberId === memberId) {
                    return { ...member, issuerAssignedMemberId: e };
                }
                return member;
            }),
        );
    };

    return { familyMembers, handleInputChange };
};

export const useReason = () => {
    const [reason, setReason] = useState<IReasonState>({ overrideCommentText: '' });
    const maxChars = useMemo(
        () => TEXTAREA_MAX_LENGTH - reason.overrideCommentText.length,
        [reason.overrideCommentText],
    );

    return { reason, setReason, maxChars, TEXTAREA_MIN_LENGTH, TEXTAREA_MAX_LENGTH };
};

export const usePolicy = () => {
    const [policy, setPolicy] = useState<IPolicy>({ issuerAssignedPolicyId: '' });

    return { policy, setPolicy };
};
